import _ from 'lodash';

// Convert LocalDateDto to datetime. 
const localDateToDate = (localDate) => {
    const dateTime = new Date();

    dateTime.setHours(0, 0, 0, 0);
    dateTime.setFullYear(localDate.year);
    dateTime.setMonth(localDate.month);
    dateTime.setDate(localDate.day);

    return dateTime;
};


export default {
    'localDateToDate': (aLocalDate) => localDateToDate(aLocalDate),
};
